import React from 'react';
import { Menu, MenuButton, Button, useDisclosure } from '@chakra-ui/core';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { PositionFromPositionList } from '../PositionType';
import PositionRequisitions from './PositionRequisitions';
import { ViewRequisitionDetail } from '../../../messaging/seeker/candidate/history/ViewRequisitionDetail';
import { Requisition } from '../../../../firebase/firestore/documents/requisition';
import colors from '../../../../styles/colors';
import { RequisitionDetailsView } from '../../../dashboard/requisitionOverview/requisitionDetails/RequisitionDetailsView';
import { NewRequisition } from '../../../dashboard/requisitionOverview/requisitionDetails/types/requistionDetails';
import { isNewRequisition } from '../../../dashboard/requisitionOverview/requisitionDetails/utils/requisitionDetailsUtils';

export type PositionRequisitionsProps = {
  position: PositionFromPositionList;
  isLastItem: boolean;
};
export const PositionRequisitionMenuButton = ({ position, isLastItem }: PositionRequisitionsProps): JSX.Element => {
  const { t } = useTranslation();
  const [requisition, setRequisition] = React.useState<Requisition | NewRequisition | undefined>(undefined);
  const { isOpen: isOpenRequisition, onOpen: onOpenRequisition, onClose: onCloseRequisition } = useDisclosure();
  return (
    <>
      <Menu placement={isLastItem ? 'top' : /* istanbul ignore next */ 'bottom'}>
        <>
          <MenuButton
            // eslint-disable-next-line
            as={Button as any}
            rightIcon={<RiArrowDownSLine />}
            size="sm"
            background={colors.input.background}
            transition="all 0.2s"
            borderRadius="md"
            borderWidth="1px"
            border="none"
            mr={2}
            data-testid={`RequisitionsButton-${position.id}`}
            _hover={{ bg: colors.lavenderMist }}
            _expanded={{ bg: colors.blue[500], color: '#fff' }}
          >
            {t('common:requisitions')}
          </MenuButton>
          <PositionRequisitions positionId={position.id} onOpenRequisition={onOpenRequisition} setRequisition={setRequisition} />
        </>
      </Menu>

      {isOpenRequisition &&
        (isNewRequisition(requisition as Requisition | NewRequisition) ? (
          <RequisitionDetailsView
            isOpen={isOpenRequisition}
            onClose={onCloseRequisition}
            requisition={requisition as NewRequisition}
          />
        ) : (
          <ViewRequisitionDetail
            isOpen={isOpenRequisition}
            onClose={onCloseRequisition}
            shouldCompare={false}
            requisition={requisition as Requisition}
            showReqStatus
          />
        ))}
    </>
  );
};
